import { IconPDF } from 'components/IconPDF/IconPDF';
import React from 'react';
import { IsFree, LastColWrapper } from 'styles/Table.styled';
import { toLocale } from 'utils/filters';

export const columns = [
    {
        Header: '№ garażu',
        accessor: 'garageNumber',
    },
    {
        accessor: 'garageArea',
        Header: 'Metraż',
        Cell: (data: any) => {
            return (
                <span>
                    {data?.cell?.value} m<sup>2</sup>
                </span>
            );
        },
    },
    {
        Header: 'Cena',
        accessor: 'garagePrice',
        Cell: (data: any) => {
            return <span>{toLocale(data?.cell?.value)} zł</span>;
        },
    },
    {
        Header: 'Status',
        accessor: 'garageStatus',
        Cell: (data: any) => {
            return (
                <IsFree isFree={data?.row?.original?.garageStatus}>
                    {data?.row?.original?.garageStatus}
                </IsFree>
            );
        },
    },
    {
        Header: 'Status',
    },
];
